import React from 'react';
import { Result, Button } from 'antd';

export default function Error404() {
	return (
		<Result
			status="404"
			title="404"
			subTitle="Lo sentimos, La página a la que deseas ingresar no existe."
			//extra={<Button type="primary">Back Home</Button>}
		/>
	);
}
